import { TranslationKeys } from './en';

export const lv: TranslationKeys = {
  // Navigācija
  nav: {
    home: "Sākums",
    shop: "Veikals",
    lighting: "Apgaismojums",
    electricity: "Elektrība",
    hardware: "Furnitūra",
    accessories: "Aksesuāri",
    cart: "Grozs",
    search: "Meklēt",
    menu: "Izvēlne",
    sale: "Izpārdošana",
    allCategories: "Visas kategorijas",
  },
  
  // Kategorijas
  categories: {
    lighting: "Apgaismojums",
    electricity: "Elektrība",
    hardware: "Furnitūra",
    accessories: "Aksesuāri",
    kitchens: "Virtuve",
    // Apgaismojuma apakškategorijas
    chandeliers: "Lustras",
    ceilingLights: "Griestu lampas",
    wallLights: "Sienas lampas",
    outdoorLighting: "Āra apgaismojums",
    lightBulbs: "Spuldzes",
    // Elektroinstalācijas apakškategorijas
    lightSwitches: "Gaismas slēdži",
    dimmerSwitches: "Dimmera slēdži",
    plugSockets: "Kontaktligzdas",
    backBoxes: "Montāžas kārbas",
    plates: "Rāmīši",
    modules: "Moduļi",
    otherSwitches: "Citi slēdži",
    toggleSwitches: "Toggle slēdži",
    rockerSwitches: "Rocker slēdži",
    ukProducts: "UK produkti",
    doorHandle: "Durvju rokturi",
    fixedDoorHandle: "Fiksētie durvju rokturi",
    doorKnob: "Durvju pogas",
    fixedDoorKnob: "Fiksētās durvju pogas",
    doorHinge: "Durvju eņģes",
    doorStop: "Durvju aizturi",
    closetBar: "Skapju rokturi",
    deadboltLatch: "Aizbīdnis",
    mirror: "Spogulis",
    spares: "Rezerves daļas",
    // Aksesuāru apakškategorijas
    jewellery: "Rotaslietas",
    pets: "Mājdzīvniekiem",
    machined: "Dekori",
    // Virtuves apakškategorijas
    cookware: "Virtuves piederumi",
    mixerFaucets: "Virtuves krāni",
    kitchenFaucets: "Virtuves krāni",
    kitchenShelves: "Virtuves plaukti",
    kitchenGirderShelf: "Sijas plaukts",
    kitchenHangerShelf: "Piekārts plaukts",
    fryingPans: "Pannas",
    pots: "Katli",
    // Deante produktu tipi - Virtuve
    sinks: "Izlietnes",
    graniteSinks: "Granīta izlietnes",
    steelSinks: "Tērauda izlietnes",
    ceramicSinks: "Keramikas izlietnes",
    soapDispensers: "Ziepju dozatori",
    drainers: "Noteces",
    baskets: "Grozi",
    cuttingBoards: "Griešanas dēļi",
    kitchenAccessories: "Virtuves aksesuāri",
    // Deante produktu tipi - Vannasistaba
    bathroomFaucets: "Vannas krāni",
    basinFaucets: "Izlietnes krāni",
    bathFaucets: "Vannas krāni",
    showerFaucets: "Dušas krāni",
    bidetFaucets: "Bidē krāni",
    concealedFaucets: "Iebūvējamie krāni",
    showerSystems: "Dušas sistēmas",
    showerColumns: "Dušas kolonnas",
    showerHeads: "Dušas galvas",
    handShowers: "Rokas dušas",
    showerTrays: "Dušas paliktņi",
    showerEnclosures: "Dušas kabīnes",
    showerDrains: "Dušas noteces",
    basins: "Izlietnes",
    toilets: "Tualetes podi",
    toiletSeats: "Tualetes sēdekļi",
    toiletPaperHolders: "Tualetes papīra turētāji",
    toiletFrames: "Tualetes rāmji",
    wcFlushButtons: "Tualetes pogas",
    bidets: "Bidē",
    bathroomAccessories: "Vannas aksesuāri",
    towelRails: "Dvieļu turētāji",
    soapDishes: "Ziepju trauki",
    tumblers: "Glāzes",
    toiletBrushes: "Tualetes birstes",
    dispensers: "Dozatori",
    mirrors: "Spoguļi",
    bathroomShelves: "Vannas plaukti",
    bathroomFurniture: "Vannas mēbeles",
    bathroomCabinets: "Vannas skapīši",
    vanityUnits: "Izlietnes skapīši",
    kitchen: "Virtuve",
    bathroom: "Vannasistaba",
    pendants: "Piekarināmās lampas",
    tableLamps: "Galda lampas",
    floorLamps: "Grīdas lampas",
    spotLights: "Punktveida gaismekļi",
    keyrings: "Atslēgu piekariņi",
    gifts: "Dāvanas",
    // Papildu Deante apakškategorijas
    bathtubs: "Vannas",
    freestandingBath: "Brīvstāvošās vannas",
    builtInBath: "Iebūvējamās vannas",
    bathSpouts: "Vannas iztekas",
    showerRails: "Dušas stieņi",
    basinWaste: "Izlietnes sifonas",
    showerWaste: "Dušas sifonas",
    radiatorValves: "Radiatoru vārsti",
    rails: "Sliedes",
  },

  // Hero sekcija
  hero: {
    title: "",
    titleAccent: "Dizains",
    titleEnd: "Kas Kļūst par Mākslu",
    subtitle: "Rūpīgi atlasīta premium interjera furnitūras, apgaismojuma, virtuves risinājumu un dizaina elementu kolekcija. Tiem, kam svarīga katra detaļa.",
    shopCollection: "Skatīt Kolekciju",
    exploreRange: "Izpētīt Klāstu",
  },

  // Produkts
  product: {
    addToCart: "Pievienot grozam",
    outOfStock: "Nav pieejams",
    quantity: "Daudzums",
    sku: "Artikuls",
    price: "Cena",
    finish: "Apdare",
    size: "Izmērs",
    logo: "Logo",
    knurl: "Rievojums",
    viewDetails: "Skatīt detaļas",
    viewAll: "Skatīt visus",
    noProducts: "Produkti nav atrasti",
    noProductsDesc: "Mēģiniet mainīt filtrus vai pārlūkojiet visus produktus.",
    clearFilters: "Notīrīt filtrus",
    featuredProducts: "Ieteicamie produkti",
    shopFullCollection: "Skatīt visu kolekciju",
  },

  // Veikala lapa
  shop: {
    title: "Visi produkti",
    subtitle: "Izpētiet mūsu pilno premium arhitektūras furnitūras, apgaismojuma un elektroinstalācijas kolekciju.",
    collection: "Kolekcija",
    category: "Kategorija",
    allCategories: "Visas kategorijas",
    productType: "Produkta tips",
    allTypes: "Visi tipi",
    collectionFilter: "Kolekcija",
    allCollections: "Visas kolekcijas",
    brand: "Zīmols",
    allBrands: "Visi zīmoli",
    sortBy: "Kārtot pēc",
    default: "Noklusējums",
    priceLowHigh: "Cena: no zemākās",
    priceHighLow: "Cena: no augstākās",
    nameAZ: "Nosaukums: A-Z",
    nameZA: "Nosaukums: Z-A",
    show: "Rādīt",
    items: "",
    hideUKProducts: "Slēpt UK produktus",
    clearAll: "Notīrīt visu",
    products: "produkti",
    product: "produkts",
    loading: "Ielādē...",
    previous: "Iepriekšējā",
    next: "Nākamā",
    searchPlaceholder: "Meklēt produktus...",
    noProducts: "Produkti nav atrasti",
    loadAllProducts: "Ielādēt visus produktus",
    loadingAll: "Ielādē visus...",
    price: "Cena",
    priceRange: "Cenu diapazons",
  },

  // Produkta detaļas
  productDetail: {
    home: "Sākums",
    products: "Produkti",
    fastShipping: "Ātra piegāde",
    warranty: "Garantija",
    returns: "30 dienu atgriešana",
    lifestyle: "Dzīvesstils",
    details: "Detaļas",
    whatsInBox: "Iepakojuma saturs",
    specifications: "Specifikācijas",
    dimensions: "Izmēri",
    electrical: "Elektrība",
    lightingSpecs: "Apgaismojums",
    hardwareSpecs: "Furnitūra",
    documents: "Dokumenti",
    lineDrawing: "Rasējums",
    specSheet: "Specifikāciju lapa",
    instructionManual: "Lietošanas instrukcija",
    download: "Lejupielādēt",
    noImage: "Nav attēla",
    productNotFound: "Produkts nav atrasts",
    backToStore: "Atpakaļ uz veikalu",
    imageDisclaimer: "Attēlam ir ilustratīva nozīme un prece var atšķirties no attēlā redzamā.",
    components: "Sastāvdaļas",
    componentsDesc: "Šis produkts sastāv no:",
    // Iepakojuma izmēru sekcija
    packageDimensions: "Iepakojuma izmēri",
    productDimensions: "Produkta izmēri",
    width: "Platums",
    height: "Augstums",
    length: "Garums",
    weight: "Svars",
    minWidth: "Min. platums",
    minHeight: "Min. augstums",
    // Specifikāciju etiķetes
    packageWidth: "Iepakojuma platums",
    packageHeight: "Iepakojuma augstums",
    packageLength: "Iepakojuma garums",
    packageWeight: "Iepakojuma svars",
    itemWeight: "Preces svars",
    minLength: "Garums",
    internalDepth: "Iekšējais dziļums",
    externalDepth: "Ārējais dziļums",
    projection: "Izvirzījums",
    voltage: "Spriegums",
    amperage: "Ampēri",
    frequency: "Frekvence",
    ipRating: "IP klase",
    ceGrade: "CE klase",
    numBulbs: "Spuldžu skaits",
    bulbBase: "Spuldzes tips",
    bulbType: "Spuldzes veids",
    maxWattage: "Maks. jauda",
    lumen: "Gaismas plūsma",
    dimmable: "Regulējams",
    kelvin: "Krāsu temperatūra",
    cri: "CRI",
    lifeHours: "Kalpošanas laiks",
    cordLength: "Vada garums",
    distanceBetweenHoles: "Attālums starp caurumiem",
    roseDiameter: "Rozes diametrs",
    barDiameter: "Stieņa diametrs",
    spindleDimension: "Vārpstas izmērs",
    plateMaterial: "Plates materiāls",
    switchType: "Slēdža tips",
  },

  // Grozs
  cart: {
    title: "Iepirkumu grozs",
    empty: "Jūsu grozs ir tukšs",
    emptyDesc: "Pievienojiet produktus, lai sāktu",
    continueShopping: "Turpināt iepirkties",
    subtotal: "Starpsumma",
    subtotalExVat: "Starpsumma (bez PVN)",
    vatAmount: "PVN (21%)",
    checkout: "Noformēt pasūtījumu",
    remove: "Noņemt",
    addedToCart: "Pievienots grozam",
    viewCart: "Skatīt grozu",
    // Business customer cart
    businessCheckout: "Pasūtīt ar rēķinu",
    shopifyCheckout: "Apmaksāt tagad",
    yourDiscount: "Jūsu atlaide",
    vatIncluded: "PVN (21%) iekļauts cenā",
    orderPlaced: "Pasūtījums veiksmīgi noformēts",
    orderPlacedDesc: "Rēķins tiks nosūtīts uz jūsu e-pastu",
    paymentTerms: "Apmaksas termiņš",
    days: "dienas",
    total: "Kopā",
    // Shipping & Delivery
    shippingCountry: "Piegādes valsts",
    selectCountry: "Izvēlieties valsti",
    shipping: "Piegāde",
    freeShipping: "Bezmaksas",
    freeShippingFrom: "Bezmaksas piegāde no",
    calculatedAtCheckout: "Aprēķināts checkout",
    shippingNote: "Piegādes veidu izvēlēsieties checkout",
    selectCountryForShipping: "Izvēlieties valsti",
    secureCheckout: "Drošs maksājums ar Shopify",
    agreeToTerms: "Piekrītu",
    purchaseTermsLink: "Pirkšanas nosacījumiem",
    deliveryAddress: "Piegādes adrese",
    deliveryMethod: "Piegādes veids",
    pickupInStore: "Izņemt veikalā",
    free: "BEZMAKSAS",
    deliveryToAddress: "Piegāde uz adresi",
    deliveryPriceNote: "Piegādes maksa atkarīga no svara un valsts",
    savedAddress: "Saglabātā adrese",
    newAddress: "Cita adrese",
    address: "Adrese",
    fillDeliveryAddress: "Lūdzu aizpildiet visus piegādes adreses laukus",
    back: "Atpakaļ",
    backToCart: "Atpakaļ uz grozu",
    proceedToDelivery: "Turpināt uz piegādi",
    createInvoice: "Izveidot rēķinu",
    confirmOrder: "Apstiprināt pasūtījumu",
    invoiceWillBeSent: "Rēķins tiks nosūtīts uz jūsu e-pastu",
    country: "Valsts",
    city: "Pilsēta",
    postalCode: "Indekss",
    streetAddress: "Iela, mājas nr.",
    storePickup: "Izņemšana veikalā",
    // Omniva
    parcelLocker: "Pakomāts",
    selectParcelLocker: "Izvēlēties pakomātu",
    searchTerminals: "Meklēt pēc pilsētas vai adreses...",
    loadingTerminals: "Ielādē pakomātus...",
    noTerminalsFound: "Pakomāti nav atrasti",
    terminalsAvailable: "pakomāti pieejami",
    omnivaDelivery: "Omniva pakomāts",
    omnivaNote: "Ērta saņemšana pakomātā 24/7",
    courierDelivery: "Kurjera piegāde",
    courierNote: "Piegāde uz jūsu adresi",
    selectDeliveryMethod: "Izvēlieties piegādes veidu",
    orderNotes: "Pasūtījuma piezīmes",
    orderNotesPlaceholder: "Pievienojiet papildu norādes vai piezīmes pasūtījumam...",
    promoPlaceholder: "Promo kods",
    applyPromo: "Pielietot",
    promoApplied: "Promo kods pielietots!",
    promoInvalid: "Nederīgs promo kods",
    promoRemoved: "Promo kods noņemts",
    promoNotAvailableWithSale: "Promo kodi nav pieejami produktiem ar atlaidi",
  },

  // Bizness
  business: {
    login: "Biznesa ieeja",
    register: "Biznesa reģistrācija",
    companyName: "Uzņēmuma nosaukums",
    registrationNumber: "Reģistrācijas numurs",
    vatNumber: "PVN numurs",
    contactName: "Kontaktpersona",
    phone: "Tālrunis",
    billingAddress: "Norēķinu adrese",
    city: "Pilsēta",
    postalCode: "Pasta indekss",
    country: "Valsts",
    alreadyHaveAccount: "Jau ir konts?",
    noAccount: "Nav konta?",
    registerHere: "Reģistrēties šeit",
    loginHere: "Ieiet šeit",
    awaitingApproval: "Gaida apstiprinājumu",
    awaitingApprovalDesc: "Jūsu biznesa konts gaida apstiprinājumu. Jūs tiksiet informēts, kad tas būs apstiprināts.",
    dashboard: "Biznesa panelis",
    yourOrders: "Jūsu pasūtījumi",
    noOrders: "Vēl nav pasūtījumu",
    orderNumber: "Pasūtījuma numurs",
    orderDate: "Datums",
    status: "Statuss",
    total: "Summa",
    paymentStatus: "Apmaksas statuss",
    dueDate: "Apmaksas termiņš",
    viewInvoice: "Skatīt rēķinu",
  },

  // Kājene
  footer: {
    company: "Uzņēmums",
    about: "Par mums",
    contact: "Kontakti",
    careers: "Karjera",
    support: "Atbalsts",
    faq: "BUJ",
    shipping: "Piegāde",
    returnsPolicy: "Atgriešana",
    legal: "Juridiskā info",
    privacy: "Privātuma politika",
    terms: "Lietošanas noteikumi",
    cookies: "Sīkdatņu politika",
    newsletter: "Jaunumi",
    newsletterDesc: "Piesakieties jaunumiem un ekskluzīviem piedāvājumiem",
    subscribe: "Pieteikties",
    emailPlaceholder: "Ievadiet e-pastu",
    blog: "Blogs",
    allRightsReserved: "Visas tiesības aizsargātas",
    regNr: "Reģ. nr.",
    vatNr: "PVN nr.",
    euSupportTitle: "ES Atveseļošanas fonds",
    euSupportText: "Sabiedrība ar ierobežotu atbildību \"Royal Bathrooms\", reģ.nr. 40103384776, Atveseļošanas fonda ietvaros veic ieguldījumu komercdarbības procesu uzlabošanā.",
    euSupportActivity: "Atbalstāmā darbība: pārdošanas procesi",
    euSupportSolution: "Risinājums: pilnvērtīgs interneta veikala risinājums uzņēmuma ekomercijas attīstībai.",
    purchaseTerms: "Pirkšanas nosacījumi",
    workingHours: "Darba laiks",
    workingHoursWeekdays: "P.–Pk.: 10:00–18:00",
    workingHoursSaturday: "S.: 10:00–15:00",
    workingHoursSunday: "Sv.: Slēgts",
  },

  purchaseTerms: {
    title: "Pirkšanas nosacījumi",
    metaDescription: "HAUS interneta veikala pirkšanas nosacījumi — garantija, atteikuma tiesības, cenas, piegāde.",
    lastUpdated: "Pēdējo reizi atjaunināts",
    warrantyTitle: "Garantija",
    warrantyIntro: "Visām interneta veikalā www.haus.lv iegādātajām precēm tiek nodrošināta ražotāja garantija. Minimālais garantijas termiņš fiziskām personām ir 24 mēneši, saskaņā ar Latvijas Republikas normatīvajiem aktiem. Atsevišķām precēm ražotājs var noteikt garāku garantijas periodu. Lai izmantotu garantiju, nepieciešams uzrādīt pirkumu apliecinošu dokumentu (rēķinu vai pavadzīmi).",
    warrantyItem1: "Preces piederumiem un aksesuāriem (piemēram, baterijām, spuldzēm u.c.), ja to nolietojums ir dabisks.",
    warrantyItem2: "Detaļām, kuru nolietojums ir normāls lietošanas rezultāts.",
    warrantyItem3: "Nelieliem vizuāliem defektiem, kas neietekmē preces funkcionalitāti.",
    warrantyExcludesTitle: "Garantija neattiecas uz:",
    warrantyExclude1: "Preces piederumiem un aksesuāriem (piemēram, baterijām, spuldzēm u.c.), ja to nolietojums ir dabisks.",
    warrantyExclude2: "Detaļām, kuru nolietojums ir normāls lietošanas rezultāts.",
    warrantyExclude3: "Nelieliem vizuāliem defektiem, kas neietekmē preces funkcionalitāti.",
    warrantyVoidTitle: "Garantija nav spēkā, ja:",
    warrantyVoid1: "Prece ir mehāniski bojāta vai izmantota neatbilstoši lietošanas instrukcijai.",
    warrantyVoid2: "Veikts nesankcionēts remonts.",
    warrantyVoid3: "Bojājumi radušies ārēju faktoru ietekmē (mitrums, sprieguma svārstības, ugunsgrēks u.c.).",
    warrantyVoid4: "Nav ievēroti uzstādīšanas vai lietošanas nosacījumi.",
    warrantyLaw: "Garantijas gadījumi tiek izskatīti saskaņā ar Latvijas Republikas normatīvajiem aktiem.",
    withdrawalTitle: "Atteikuma tiesības",
    withdrawalItem1: "Pircējam (patērētājam) ir tiesības atteikties no distances līguma 14 dienu laikā no preces saņemšanas dienas, nenorādot iemeslu.",
    withdrawalItem2: "Pircējs ir atbildīgs par preces vērtības samazināšanos, ja prece izmantota vairāk nekā nepieciešams tās īpašību un darbības pārbaudei.",
    withdrawalItem3: "Precei jābūt atgrieztai oriģinālajā komplektācijā.",
    withdrawalExcludesTitle: "Atteikuma tiesības neattiecas uz:",
    withdrawalExclude1: "Precēm, kas izgatavotas pēc individuāla pasūtījuma.",
    withdrawalExclude2: "Precēm, kuras pēc piegādes ir neatgriezeniski sajauktas ar citām.",
    withdrawalExclude3: "Precēm, kuras higiēnas apsvērumu dēļ nevar atgriezt, ja tās pēc piegādes ir atvērtas.",
    withdrawalRefund: "Naudas atmaksa tiek veikta 14 dienu laikā pēc atteikuma paziņojuma saņemšanas, bet ne agrāk kā pēc preces saņemšanas atpakaļ.",
    pricingTitle: "Cenas un pieejamība",
    pricingItem1: "Cenas un preču pieejamība interneta veikalā var tikt mainīta bez iepriekšēja brīdinājuma.",
    pricingItem2: "Visas cenas ir norādītas eiro (EUR) ar iekļautu pievienotās vērtības nodokli (PVN).",
    pricingItem3: "Eiropas Savienības uzņēmumiem, kas ir PVN maksātāji un neatrodas Latvijā, iespējams piemērot 0% PVN likmi, ievērojot normatīvos aktus.",
    privacyTitle: "Privātuma politika",
    privacyText: "Klienta sniegtā informācija tiek izmantota tikai pasūtījumu apstrādei un klientu apkalpošanai. Informācija netiek nodota trešajām personām, izņemot gadījumus, kad tas ir nepieciešams piegādes nodrošināšanai vai to paredz normatīvie akti.",
    privacyDataTitle: "Pasūtījuma apstrādei nepieciešamā informācija:",
    privacyData1: "Vārds un uzvārds",
    privacyData2: "Piegādes adrese",
    privacyData3: "Kontakttālrunis",
    privacyData4: "E-pasta adrese",
    privacyEmail: "E-pasta adrese tiek izmantota pasūtījuma apstiprināšanai un saziņai ar klientu. Reklāmas ziņojumi tiek sūtīti tikai ar klienta piekrišanu.",
    passwordTitle: "Paroles drošība",
    passwordText: "Klienta paroles netiek uzglabātas pieejamā veidā. Paroles atjaunošana iespējama, izmantojot funkciju \"Aizmirsu paroli\".",
    deliveryTitle: "Piegādes nosacījumi",
    deliveryItem1: "Ja klients nav sasniedzams piegādes laikā vai neizņem sūtījumu noteiktajā termiņā, atkārtota piegāde var tikt veikta par papildu samaksu.",
    deliveryItem2: "Ja pircējs atsakās no pasūtījuma pēc tā izsūtīšanas, pārdevējam ir tiesības ieturēt piegādes izmaksas no atmaksājamās summas.",
    otherTitle: "Citi nosacījumi",
    otherText: "Ja pasūtītā prece tehnisku vai noliktavas kļūdu dēļ nav pieejama, klientam tiek piedāvāta alternatīva prece vai tiek veikta pilna samaksātās summas atmaksa.",
  },

  // Vispārīgi
  common: {
    loading: "Ielādē...",
    error: "Kļūda",
    close: "Aizvērt",
    save: "Saglabāt",
    cancel: "Atcelt",
    confirm: "Apstiprināt",
    yes: "Jā",
    no: "Nē",
    or: "vai",
  },

  // Par mums sekcija
  about: {
    tagline: "Par HAUS",
    title: "Tavs partneris",
    titleAccent: "Dizaina izcilībā",
    paragraph1: "HAUS ir rūpīgi atlasīta premium arhitektūras furnitūras, apgaismojuma un interjera dizaina elementu kolekcija. Mēs apvienojam pasaules labākos zīmolus prasīgiem māju īpašniekiem, arhitektiem un interjera dizaineriem.",
    paragraph2: "Bāzējoties Latvijā, mēs apkalpojam klientus visā Baltijas reģionā un Eiropā, piedāvājot ekskluzīvu piekļuvi tādiem zīmoliem kā Buster + Punch un citiem premium ražotājiem.",
    paragraph3: "Katrs produkts mūsu kolekcijā ir rūpīgi atlasīts pēc tā izcilās meistarības, inovatīvā dizaina un ilgstošās kvalitātes. Mēs ticam, ka detaļas ir svarīgas – no slēdža uz sienas līdz rokturim uz durvīm.",
  },

  // Buster + Punch sekcija
  busterPunch: {
    exclusivePartner: "EKSKLUZĪVS PARTNERIS",
    brandDescription: "Londonā dzimis dizaina zīmols, kas rada izsmalcinātu metāla furnitūru, apgaismojumu un interjera detaļas ar neatkārtojamu raksturu un attieksmi.",
    theStory: "STĀSTS",
    mastersOfMetal: "Metāla meistari kopš 2013. gada",
    storyParagraph1: "Buster + Punch 2013. gadā dibināja arhitekts Massimo Buster Minale ar mērķi radīt pasaulē izcilākās masīvā metāla interjera detaļas. Šodien, iedvesmojoties no Londonas mainīgajām kultūras strāvām, Buster + Punch kolekcijas pārveido mājas un telpas visā pasaulē.",
    storyParagraph2: "Nozares profesionāļiem zīmols ir neapstrīdams metāla meistars, kas rada izsmalcinātas funkcionālas detaļas, kuras ne tikai paaugstina telpu līmeni, bet arī raisa kaislību un individualitāti. Buster + Punch bezkompromisa uzmanība detaļām un premium masīvā metāla izmantošana ir padarījusi interjera detaļas līdzvērtīgas izcilām mēbelēm.",
    storyParagraph3: "Ar estētiku un zīmola identitāti, kas līdzinās kulta augstās modes zīmoliem, Buster + Punch ir attieksme un dzīvesveids saviem sekotājiem. Sadarbības apvieno dizainu ar modi, mūziku, mākslu un kultūru.",
    storyHighlight: "Pirmie, kas ieviesa precīzo rievošanu interjera furnitūrā. Vārds, kas simbolizē masīvā metāla slēdžus un rozetes. Pirmais zīmols pasaulē, kas 2015. gadā laida klajā dizaina LED spuldzi.",
    discoverCollection: "Atklāj pilno kolekciju",
    discoverCollectionDesc: "Izpēti visu Buster + Punch produktu klāstu, kas pieejams caur HAUS",
    shopBusterPunch: "PIRKT BUSTER + PUNCH",
    founderQuote1: "Esmu lepns, ka mēs bijām pirmie, kas iedzīvināja funkcionālās mājas detaļas caur mūsu aizraušanos ar metāliem. Mūsu oriģinalitāte, unikālais skatījums un pieeja ir izveidojuši jaunus ceļus interjeros jau desmit gadus.",
    founderQuote2: "Kā zīmols mēs vienmēr esam pieņēmuši pārmaiņas. Šodien mūsu pasaule krasi atšķiras no mūsu mazajiem garāžas sākumiem. Toreiz iedvesma ziedēja no Londonas ietvju plaisām, bet tagad mūsu debesskrāpji slejas un sociālie mediji cenšas mūs izolēt no ielām, pa kurām kādreiz staigājām. Šīs pārmaiņas ir iespējas atklāt jaunas iedvesmas, talantus un tehnikas, paliekot uzticīgiem savām saknēm.",
    founderQuote3: "Kā zīmols mēs apņemamies būt atbildīgāki un nodrošināt, lai mūsu produkti paliek jēgpilni un unikāli. Mēs paliksim analogi un taktiski, skatoties uz priekšu – apvienojot tradīcijas ar tehnoloģijām, lai veidotu jaunas nodaļas. Pārkāpjot nozares robežas un smeļoties iedvesmu no mūsu pilsētas subkultūrām, mēs apsolām prioritizēt savus cilvēkus, klientus un kopienu, novietojot viņus mūsu pasaules centrā.",
    founderName: "MASSIMO BUSTER MINALE",
    founderRole: "Dibinātājs un radošais direktors",
    // Elektrības kolekcija
    electricityTitle: "Elektrības kolekcija",
    electricitySubtitle: "EIROPAS KLĀSTS",
    electricityDesc: "Buster + Punch pieprasītā ELECTRICITY kolekcija tagad ir pieejama kā Eiropai specifisks klāsts. Plašs gaismas slēdžu, dimeru, rozešu un kontaktligzdu klāsts, kas burtiski maina jūsu priekšstatu par mājas detaļām ar vienu slēdža kustību.\n\nIzstrādāts Londonā un iedvesmots no mikserpultīm un pastiprinātājiem, klāsts ir izgatavots no masīviem dārgmetāliem, rievots ar dimanta uzgaļiem aprīkotām CNC virpām un precīzi apdstrādāts ar roku.\n\nELECTRICITY ir Buster + Punch ētikas produkts – pārvērst \"parastus\" produktus, dizainus un detaļas ārkārtas pieredzēs. Kā klāsts tie paver jaunu veidu, kā projektēt ar detaļām, sasaistot telpas ar taktiālu sarkano pavedienu.\n\nKolekcija ir pieejama pilnos komplektos vai pielāgotās modulārās vienībās ar 11 dažādām kombinācijām. Izvēlieties no tērauda, misiņa, kūpinātas bronzas, melnas un baltas krāsas. Klāstā ir arī \"retractive slēdži\", kas var tikt izmantoti ar viedās mājas risinājumiem.",
    electricityQuote: "Mēs vienmēr esam jutūši, ka trūkst skaistuma un sajūtas interjera detaļās, kad runa ir par šīm lietām. Tās ir būtiskas detaļas, bet ir grūti saprast, kāpēc neviens agrāk nav ieguldījis rūpes un aizrautību tajās. Citās mūsu dzīves jomās slēdžiem un pogām tiek piešķirti skaisti dizaini un apstrāde – automašīnām, piemēram, vai ģitāras pastiprinātājiem, pat tālvadības pultīm.",
    // Linear sērija
    linearTitle: "Linear sērija — Slēdži, dimeri un rozetes",
    linearSubtitle: "IKONAS JAUNĀ IZSKATĀ",
    linearDesc: "Buster + Punch šovasar atgriežas pie mikserpults, lai pārstrādātu savus ikoniskos masīvā metāla slēdžus, dimerus un rozetes – šoreiz ar zīmola precīzi izgatavoto lineāro rievošanu kā galveno estētiku. Smeļoties iedvesmu no klasiskajiem analogajiem pastiprinātājiem un Šveices pulksteņniecības pasaules, šīs obligātās interjera detaļas ir pārveidotas ar rūpīgu uzmanību detaļām.\n\nBuster + Punch masīvā metāla, precīzi rievotie slēdži, dimeri un rozetes ir vieni no pasaulē pieprasītākajiem interjera elementiem. Mīlēti A-saraksta zvaigžņu, dizaineru, arhitektu un gaumes noteicēju vidū, to premium materiāli un neatkārtojamā analogā darbība aizrauj ikvienu, kas ar tiem saskaras.\n\nJaunie slēdži, dimeri un rozetes papildina Linear sēriju un paplašina klāstu ar perfektu nepārtrauktību. Kolekcija pievienojas Buster + Punch visaptverošajam interjera detaļu klāstam, ļaujot Linear izskatu ieviest visā mājas furnitūrā, apgaismojumā, aksesuāros un tagad arī elektroinstalācijā.\n\nPieejams masīvā metāla apdarēs, tostarp baltā, tērauda, misiņa, kūpinātās bronzas un melnā krāsā. Pilnībā sertificēts ES, Ziemeļamerikai, Lielbritānijai, Austrālijai un Jaunzēlandei.",
    // Verdošā ūdens krāns
    boilingTapTitle: "Verdoša ūdens krāns",
    boilingTapSubtitle: "VIRTUVES INOVĀCIJA",
    boilingTapDesc: "Buster + Punch jaunais verdošā ūdens krāns sniedz dzesēta filtrēta ūdens un tūlītēja verdoša ūdens ērtību virtuvē, apvienojot to ar savu raksturīgo estētiku un attieksmi.\n\nIzstrādāts kopā ar vienu no Eiropas vadošajiem krānu ražotājiem, krāns ir projektēts no nulles, izmantojot Buster + Punch pieredzi darbā ar masīviem metāliem. Ar raupji lietu metāla pamatni, pielāgotu izolētu slīpēta metāla kaklu, krustenisko vai lineāro rievoto masīvā metāla sviru, kā arī atbilstošu rievotu aeratora vāciņu un funkciju regulatoru.\n\nAr vienkāršu rievotā funkciju regulatora kustību jūs varat ieliet perfektu glāzi filtrēta auksta ūdens, pagatavot karstu dzērienu vai paātrināt vārīšanu ar tūlītēju 98 grādu ūdeni. Krānam ir pilnībā pielāgojami iestatījumi un funkcijas, kas novērš nejaušu karstā ūdens aktivizēšanu.\n\nBuster + Punch krāna unikālā estētika papildina tā raksturīgo skapju furnitūras klāstu, radot nemanāmu saskaņu visā virtuves telpā.",
    // Virtuve
    kitchenTitle: "Buster + Punch virtuve",
    kitchenSubtitle: "MODULĀRS BRĪVSTĀVOŠS DIZAINS",
    kitchenDesc: "Ir pagājuši laiki, kad iebūvētajām virtuvēm bija īss kalpošanas laiks un ierobežota elastība. Buster + Punch virtuve ir jauns veids, kā veidot individuāli būvētu, modulāru, brīvstāvošu virtuvi.\n\nKonfigurēta tiešsaistē un izgatavota ar tās slavenās masīvā metāla furnitūras precizitāti un inženieriju, virtuve nes estētikas un kvalitātes līmeni, kādu jūs sagaidītu no pasūtījuma mēbelēm.\n\nIedvesmojoties no profesionālo šefpavāru brīvstāvošās virtuves, dizains atbrīvo modulāro elementu sastāvdaļas. Virtuve tiek veidota no divām rāmja opcijām, trim skapju krāsām un trim darba virsmām, projektēta ap zīmola bezgalīgajām ikoniskās furnitūras izvēlēm – Buster + Punch virtuves rotaslietām.\n\nVirtuves moduļiem ir malas-līdz-malai darba virsma no akmens vai metāla ar unikālu stūra rādiusu, kas atbilst ekstrudētajam metāla rāmim. Pašam rāmim ir precīzi lietas alumīnija kājas, kas balstās uz pasūtījuma virpotām misiņa vai nerūsējošā tērauda regulējamām pēdiņām, apstrādātām ar zīmola raksturīgo dimanta griezuma rievošanu.",
    kitchenQuote: "Mēs vēlējāmies apgriezt virtuves dizaina konvencijas kājām gaisā, izmantojot furnitūru un detaļas kā visa procesa sākumpunktu. Rezultātā ir radusies virtuve, kas ir pielāgojama, lietojama un jūtas kā izgatavota no viena masīva metāla un akmens gabala.",
  },

  // Brenda lapa
  brandPage: {
    founded: "Dibināts",
    origin: "Izcelsme",
    website: "Mājaslapa",
    catalog: "Katalogs",
    busterPunchDescription: "Buster + Punch ir Londonā dzimis interjera zīmols ar misiju mainīt detaļas mājās un komerciālās telpās visā pasaulē. Dibināts 2013. gadā, ko izveidoja Massimo Minale, zīmols rada ārkārtas aprīkojumu ikdienas lietošanai - no slēdžiem un durvju furnitūras līdz apgaismojumam un pasūtījuma virtuvēm. Katrs izstrādājums ir projektēts Londonā un izgatavots no masīviem, augstākās klases metāliem ar fokusu uz meistarību un premium apdari.",
    deanteDescription: "Deante ir vadošais Eiropas vannas istabu un virtuves aprīkojuma ražotājs. Ar modernu dizainu, funkcionalitāti un augstiem standartiem, Deante pievērš īpašu uzmanību produktu kvalitātei un drošībai. Atklājiet izlietnes un krānus, kas pārveidos jūsu virtuvi. Viņu visaptverošais vannas istabas aprīkojums ļauj izveidot telpu, kas ir ideāla ikdienas kopšanas rituāliem. Augstas kvalitātes produkti un inovatīvi risinājumi padara katru brīdi vannas istabā par patiesu baudu.",
    karrayDescription: "K-Array ir itāļu audio uzņēmums, kas specializējas ultra-plānās, augstas veiktspējas skaļruņu sistēmās. Dibināts 1990. gadā, tie rada inovatīvus risinājumus profesionālām audio lietojumprogrammām, no koncertiem un pasākumiem līdz arhitektūras instalācijām. Viņu skaļruņi ir konstruēti tā, lai būtu praktiski neredzami, vienlaikus nodrošinot izcilu skaņas kvalitāti.",
    victoriaAlbertDescription: "Victoria + Albert Baths ir britu zīmols ar pasaules mēroga reputāciju izsmalcinātu brīvstāvošu vannu un izlietņu radīšanā. Dibināts 1996. gadā ar aizrautību par vannām un vannošanos, uzņēmumam ir galvenais birojs Apvienotajā Karalistē un ražošanas iekārtas Dienvidāfrikā. Šodien Victoria + Albert starptautiskās saknes apvieno globālo dizainu, pārdošanas un mārketinga operācijas ar iekšējo ražošanu, lai piegādātu luksusa, ilgstošus produktus. Kā augstākais kvalitātes un stila apliecinājums, mūsu modeļu klāsts ir piepildīts ar iedvesmojošiem brīvstāvošiem dizainiem, kas izgatavoti no 100% QUARRYCAST™ – Volcanic Limestone™ un augstas veiktspējas sveķu maisījuma. Dabiski balti, katrs izstrādājums tiek individuāli apstrādāts ar roku.",
    nokenDescription: "Noken ir augstākās klases vannas istabas zīmols no PORCELANOSA grupas, kas specializējas inovatīvos vannas istabas risinājumos. Ar fokusu uz modernu dizainu un ilgtspējību, Noken piedāvā brīvstāvošas vannas, izlietnes, krānus un dušas sistēmas, kas apvieno eleganci ar progresīvām tehnoloģijām.",
    teceDescription: "TECE ir vācu ražotājs, kas specializējas augstākās kvalitātes sanitāro instalāciju sistēmās. Dibināts 1955. gadā, TECE specializējas tualetes skalošanas plāksnēs, dušas notekās, cisternās un instalāciju sistēmās. Pazīstami ar inovatīvu dizainu un inženiertehnisko izcilību, TECE produkti apvieno funkcionalitāti ar mūsdienīgu estētiku.",
    tresDescription: "TRES ir spāņu ražotājs, kas specializējas augstākās kvalitātes vannas istabas un virtuves krānos. Dibināts 1947. gadā, TRES apvieno vairāk nekā 75 gadu pieredzi ar modernākajām tehnoloģijām, lai radītu inovatīvus krānu risinājumus. Pazīstami ar izcilas kvalitātes, moderna dizaina un plašu ekskluzīvu apdares klāstu, tostarp 24K zeltu un matētu rozā zeltu, TRES produkti ienes greznību un funkcionalitāti katrā telpā.",
    decorWaltherDescription: "Decor Walther ir vācu ražotājs, kas specializējas augstākās kvalitātes vannas istabas aksesuāros un spoguļos. Dibināts 1973. gadā, zīmols iemieso mūžīgu eleganci, izcilu amatniecību un augstākos kvalitātes standartus. No apgaismotiem spoguļiem un ziepju dozatoriem līdz dvieļu turētājiem un vannas istabas plauktiem — katrs Decor Walther produkts ir radīts, lai pārvērstu vannas istabu greznā patvērumā.",
    excellentDescription: "Excellent ir poļu ražotājs, kas specializējas augstākās kvalitātes vannas istabas risinājumos, tostarp dušas kabīnēs, dušas paliktņos, vannās un izlietnēs. Pazīstams ar inovatīvu stikla tehnoloģiju un modernu dizainu, Excellent produkti apvieno funkcionalitāti ar mūsdienīgu estētiku, lai radītu skaistas vannas istabas telpas.",
  },

  // Brendu sekcija
  brands: {
    tagline: "Ekskluzīvie partneri",
    title: "Mūsu zīmoli",
  },

  // Sīkdatņu paziņojums
  cookies: {
    bannerText: "Mēs izmantojam sīkdatnes, lai uzlabotu jūsu pārlūkošanas pieredzi, piedāvātu personalizētu saturu un analizētu mūsu trafiku. Noklikšķinot \"Pieņemt visas\", jūs piekrītat mūsu sīkdatņu izmantošanai.",
    learnMore: "Uzzināt vairāk",
    acceptAll: "Pieņemt visas",
    declineOptional: "Tikai nepieciešamās",
  },

  // Sīkdatņu politikas lapa
  cookiesPolicy: {
    title: "Sīkdatņu politika",
    lastUpdated: "Pēdējoreiz atjaunināts",
    whatAreCookiesTitle: "Kas ir sīkdatnes?",
    whatAreCookiesText: "Sīkdatnes ir nelieli teksta faili, kas tiek saglabāti jūsu ierīcē (datorā, planšetdatorā vai mobilajā tālrunī), kad apmeklējat tīmekļa vietni. Tās tiek plaši izmantotas, lai nodrošinātu efektīvāku vietņu darbību, labāku lietotāja pieredzi un sniegtu informāciju vietnes īpašniekiem.",
    howWeUseTitle: "Kā mēs izmantojam sīkdatnes",
    howWeUseText: "SIA \"Royal Bathrooms\" (reģistrācijas numurs 40103384776, PVN numurs LV40103384776), kas darbojas ar zīmolu HAUS, izmanto sīkdatnes šajā tīmekļa vietnē zemāk aprakstītajiem mērķiem. Izmantojot mūsu vietni, jūs piekrītat sīkdatņu izmantošanai saskaņā ar šo sīkdatņu politiku un ES Vispārīgo datu aizsardzības regulu (VDAR/GDPR), kas ieviesta Latvijas likumdošanā.",
    essentialTitle: "Nepieciešamās sīkdatnes",
    essentialText: "Šīs sīkdatnes ir absolūti nepieciešamas vietnes pareizai darbībai. Tās nodrošina pamata funkcionalitāti, piemēram, drošību, tīkla pārvaldību un pieejamību. Jūs nevarat atteikties no šīm sīkdatnēm, jo bez tām vietne nevar darboties.",
    essentialItem1: "Sesijas pārvaldība — jūs paliekat pieteikušies apmeklējuma laikā",
    essentialItem2: "Sīkdatņu piekrišanas preferences (cookie-consent) — jūsu sīkdatņu izvēļu atcerēšanās, saglabāta localStorage",
    essentialItem3: "Iepirkumu grozs — groza satura saglabāšana pārlūkošanas laikā",
    analyticsTitle: "Analītikas sīkdatnes (Google Analytics 4)",
    analyticsText: "Mēs izmantojam Google Analytics 4 (GA4, mērījumu ID: G-6J439RCQ4P), lai saprastu, kā apmeklētāji mijiedarbojas ar mūsu vietni. Šīs sīkdatnes tiek aktivizētas tikai pēc jūsu tiešas piekrišanas caur sīkdatņu banneri. GA4 iestata šādas sīkdatnes: _ga (ilgums: 2 gadi, lietotāju atšķiršanai), _ga_* (ilgums: 2 gadi, sesijas stāvokļa uzturēšanai). Visi apkopotie dati ir apkopoti un anonīmi. Google Analytics dati var tikt apstrādāti serveros ārpus Eiropas Ekonomikas zonas (EEZ), tostarp ASV. Google piedalās ES-ASV Datu privātuma sistēmā. Ja jūs nepiekrītat šīm sīkdatnēm, analītikas dati netiks apkopoti.",
    marketingTitle: "Mārketinga sīkdatnes (Meta Pixel)",
    marketingText: "Mēs izmantojam Meta Pixel (Facebook Pixel, ID: 3229144413891730), lai mērītu mūsu reklāmas efektivitāti un nodrošinātu atbilstošas reklāmas. Meta Pixel iestata šādas sīkdatnes: _fbp (ilgums: 3 mēneši, reklāmas piegādei un mērīšanai), fr (ilgums: 3 mēneši, reklāmas mērķauditorijas noteikšanai). Meta Pixel apkopotie dati var tikt pārsūtīti uz serveriem ASV. Meta piedalās ES-ASV Datu privātuma sistēmā. Šīs sīkdatnes tiek izmantotas atkārtotai mārketingam un auditorijas analīzei.",
    thirdPartyTitle: "Trešo pušu sīkdatnes",
    thirdPartyText: "Dažas sīkdatnes tiek ievietotas ar trešo pušu pakalpojumiem, kas parādās mūsu lapās. Mēs izmantojam trešo pušu pakalpojumus, piemēram, Shopify (e-komercijas funkcionalitātei) un iegulto saturu. Šīs trešās puses var iestatīt savas sīkdatnes saskaņā ar savām privātuma politikām. Mēs nekontrolējam šīs trešo pušu sīkdatnes.",
    dataTransferTitle: "Starptautiskā datu pārsūtīšana",
    dataTransferText: "Daži no mūsu izmantotajiem trešo pušu pakalpojumiem (Google, Meta) var apstrādāt datus ārpus Eiropas Ekonomikas zonas (EEZ). Šīs pārsūtīšanas tiek aizsargātas ar ES-ASV Datu privātuma sistēmu un/vai Eiropas Komisijas apstiprinātajām Standarta līguma klauzulām saskaņā ar VDAR 46. pantu.",
    managingTitle: "Sīkdatņu pārvaldīšana",
    managingText: "Jūs varat pārvaldīt savas sīkdatņu preferences caur mūsu sīkdatņu piekrišanas banneri, kad pirmo reizi apmeklējat vietni. Jūs varat arī kontrolēt sīkdatnes caur pārlūkprogrammas iestatījumiem. Lielākā daļa pārlūkprogrammu ļauj atteikties vai pieņemt sīkdatnes, dzēst esošās sīkdatnes un iestatīt preferences noteiktām vietnēm. Lūdzu, ņemiet vērā, ka nepieciešamo sīkdatņu atspējošana var ietekmēt mūsu vietnes funkcionalitāti. Jūs varat jebkurā laikā atsaukt savu piekrišanu, notīrot pārlūkprogrammas sīkdatnes un atkārtoti apmeklējot mūsu vietni — piekrišanas banneris parādīsies atkārtoti.",
    yourRightsTitle: "Jūsu tiesības saskaņā ar VDAR",
    yourRightsText: "Saskaņā ar Vispārīgo datu aizsardzības regulu (VDAR/GDPR) un Latvijas datu aizsardzības likumdošanu jums ir tiesības: piekļūt saviem personas datiem, pieprasīt datu labošanu vai dzēšanu, ierobežot vai iebilst pret datu apstrādi, datu pārnesamība, kā arī iesniegt sūdzību Datu valsts inspekcijā (www.dvi.gov.lv). Lai izmantotu kādu no šīm tiesībām, lūdzu, sazinieties ar mums, izmantojot zemāk norādīto kontaktinformāciju.",
    changesTitle: "Izmaiņas šajā politikā",
    changesText: "Mēs varam laiku pa laikam atjaunināt šo sīkdatņu politiku, lai atspoguļotu tehnoloģiju, likumdošanas vai mūsu datu prakses izmaiņas. Visas izmaiņas tiks publicētas šajā lapā ar atjauninātu pārskatīšanas datumu. Mēs iesakām periodiski pārskatīt šo politiku.",
    contactTitle: "Sazinieties ar mums",
    contactText: "Ja jums ir jautājumi par mūsu sīkdatņu izmantošanu, šo sīkdatņu politiku vai vēlaties izmantot savas datu aizsardzības tiesības, lūdzu, sazinieties ar mums:",
  },

  // Privātuma politikas lapa
  privacyPolicy: {
    seoTitle: "Privātuma politika | HAUS",
    seoDescription: "Uzziniet, kā HAUS vāc, izmanto un aizsargā jūsu personas datus saskaņā ar VDAR un Latvijas datu aizsardzības likumdošanu.",
    title: "Privātuma politika",
    lastUpdated: "Pēdējoreiz atjaunināts",
    introTitle: "Ievads",
    introText: "Šī privātuma politika izskaidro, kā SIA \"Royal Bathrooms\", kas darbojas ar zīmolu HAUS, vāc, izmanto, glabā un aizsargā jūsu personas datus, kad jūs izmantojat mūsu tīmekļa vietni www.haus.lv un mūsu pakalpojumus. Mēs esam apņēmušies aizsargāt jūsu privātumu saskaņā ar ES Vispārīgo datu aizsardzības regulu (VDAR) un Latvijas Fizisko personu datu apstrādes likumu.",
    controllerTitle: "Datu pārzinis",
    controllerText: "Par jūsu personas datu apstrādi atbildīgais datu pārzinis ir:",
    controllerName: "SIA \"Royal Bathrooms\"",
    controllerRegNr: "Reģistrācijas Nr.: 40103384776",
    controllerAddress: "Adrese: Cēsu iela 31 k-3, Rīga, LV-1012, Latvija",
    controllerEmail: "E-pasts: haus@royal-bathrooms.com",
    controllerPhone: "Tālrunis: +371 6737 6780",
    dataWeCollectTitle: "Kādus datus mēs vācam",
    dataWeCollectIntro: "Mēs vācam dažāda veida personas datus atkarībā no tā, kā jūs mijiedarbojaties ar mūsu vietni:",
    orderDataTitle: "Pasūtījumu un klientu dati",
    orderDataText: "Kad jūs veicat pasūtījumu vai izveidojat kontu, mēs vācam:",
    orderDataItem1: "Vārds un uzvārds",
    orderDataItem2: "E-pasta adrese",
    orderDataItem3: "Tālruņa numurs",
    orderDataItem4: "Piegādes un norēķinu adrese",
    orderDataItem5: "Pasūtījumu vēsture un maksājumu informācija (droši apstrādā Shopify Payments)",
    businessDataTitle: "Biznesa klientu dati",
    businessDataText: "Biznesa klientiem mēs papildus vācam: uzņēmuma nosaukumu, reģistrācijas numuru, PVN numuru, pilnvarotās kontaktpersonas datus un norēķinu/piegādes adreses rēķinu izrakstīšanai.",
    technicalDataTitle: "Tehniskie un analītikas dati",
    technicalDataText: "Kad jūs pārlūkojat mūsu vietni, mēs varam vākt: IP adresi (anonimizētu), pārlūkprogrammas tipu un versiju, ierīces informāciju, apmeklētās lapas un mijiedarbības datus — tikai ar jūsu piekrišanu caur sīkdatnēm (skatiet mūsu Sīkdatņu politiku).",
    legalBasisTitle: "Datu apstrādes tiesiskais pamats",
    legalBasisText: "Mēs apstrādājam jūsu personas datus, pamatojoties uz šādiem VDAR 6. panta tiesiskajiem pamatiem:",
    legalBasisItem1: "Līguma izpilde — apstrāde, kas nepieciešama jūsu pasūtījuma izpildei vai mūsu pakalpojumu sniegšanai (6. panta 1. punkta b) apakšpunkts)",
    legalBasisItem2: "Juridisks pienākums — apstrāde, ko prasa Latvijas nodokļu, grāmatvedības vai komerctiesību normatīvie akti (6. panta 1. punkta c) apakšpunkts)",
    legalBasisItem3: "Piekrišana — analītikas sīkdatnēm un mārketinga komunikācijai, ko jūs varat jebkurā laikā atsaukt (6. panta 1. punkta a) apakšpunkts)",
    legalBasisItem4: "Leģitīmā interese — vietnes drošībai, krāpšanas novēršanai un mūsu pakalpojumu uzlabošanai (6. panta 1. punkta f) apakšpunkts)",
    purposeTitle: "Datu apstrādes mērķi",
    purposeItem1: "Jūsu pasūtījumu apstrāde un izpilde, ieskaitot piegādi un rēķinu izrakstīšanu",
    purposeItem2: "Jūsu klienta konta pārvaldīšana un klientu atbalsta sniegšana",
    purposeItem3: "Juridisko un nodokļu saistību izpilde saskaņā ar Latvijas likumdošanu",
    purposeItem4: "Vietnes lietojuma analīze pakalpojumu uzlabošanai (ar jūsu piekrišanu)",
    purposeItem5: "Mārketinga komunikāciju sūtīšana (tikai ar jūsu tiešu piekrišanu)",
    sharingTitle: "Datu kopīgošana",
    sharingText: "Mēs varam kopīgot jūsu personas datus ar šādām saņēmēju kategorijām, tikai nepieciešamajā apjomā:",
    sharingItem1: "Shopify Inc. — mūsu e-komercijas platformas nodrošinātājs, kas apstrādā pasūtījumu un maksājumu datus",
    sharingItem2: "Piegādes pakalpojumu sniedzēji — jūsu pasūtījumu izpildei",
    sharingItem3: "Google LLC — vietnes analītikai (Google Analytics 4), tikai ar jūsu piekrišanu",
    sharingItem4: "Meta Platforms Inc. — reklāmas efektivitātes mērīšanai (Meta Pixel), tikai ar jūsu piekrišanu",
    transferTitle: "Starptautiskā datu pārsūtīšana",
    transferText: "Daži mūsu pakalpojumu sniedzēji (Shopify, Google, Meta) var apstrādāt datus ārpus Eiropas Ekonomikas zonas (EEZ), tostarp ASV un Kanādā. Šīs pārsūtīšanas tiek aizsargātas ar ES-ASV Datu privātuma sistēmu, Eiropas Komisijas apstiprinātajām Standarta līguma klauzulām un/vai pietiekamības lēmumiem saskaņā ar VDAR 45.-46. pantu.",
    retentionTitle: "Datu glabāšanas ilgums",
    retentionText: "Mēs glabājam jūsu personas datus tikai tik ilgi, cik tas nepieciešams šajā politikā aprakstītajiem mērķiem. Pasūtījumu dati tiek glabāti 5 gadus pēc darījuma, kā to prasa Latvijas nodokļu un grāmatvedības likumdošana (likums \"Par grāmatvedību\"). Konta dati tiek glabāti līdz jūs pieprasāt to dzēšanu. Analītikas dati ir anonimizēti un apkopoti. Jūs varat jebkurā laikā pieprasīt savu datu dzēšanu, ievērojot juridiskās glabāšanas prasības.",
    rightsTitle: "Jūsu tiesības",
    rightsText: "Saskaņā ar VDAR un Latvijas datu aizsardzības likumdošanu jums ir šādas tiesības attiecībā uz jūsu personas datiem:",
    rightsItem1: "Piekļuves tiesības — iegūt jūsu personas datu kopiju, ko mēs apstrādājam",
    rightsItem2: "Labošanas tiesības — labot neprecīzus vai nepilnīgus datus",
    rightsItem3: "Dzēšanas tiesības — pieprasīt datu dzēšanu (\"tiesības tikt aizmirstam\")",
    rightsItem4: "Ierobežošanas tiesības — ierobežot jūsu datu apstrādes veidu",
    rightsItem5: "Datu pārnesamības tiesības — saņemt savus datus strukturētā, mašīnlasāmā formātā",
    rightsItem6: "Iebilduma tiesības — iebilst pret apstrādi, kas balstīta uz leģitīmo interesi vai tiešo mārketingu",
    rightsComplaint: "Jums ir arī tiesības iesniegt sūdzību Datu valsts inspekcijā: www.dvi.gov.lv, e-pasts: info@dvi.gov.lv, adrese: Elijas iela 17, Rīga, LV-1050.",
    securityTitle: "Datu drošība",
    securityText: "Mēs īstenojam atbilstošus tehniskus un organizatoriskus pasākumus, lai aizsargātu jūsu personas datus pret neatļautu piekļuvi, izmainīšanu, izpaušanu vai iznīcināšanu. Mūsu vietne izmanto SSL/TLS šifrēšanu visai datu pārsūtīšanai. Piekļuve personas datiem ir ierobežota tikai pilnvarotam personālam.",
    changesTitle: "Izmaiņas šajā politikā",
    changesText: "Mēs varam laiku pa laikam atjaunināt šo privātuma politiku, lai atspoguļotu izmaiņas mūsu praksē, tehnoloģijās vai juridiskajās prasībās. Visas izmaiņas tiks publicētas šajā lapā ar atjauninātu pārskatīšanas datumu. Mēs iesakām periodiski pārskatīt šo politiku.",
    contactTitle: "Sazinieties ar mums",
    contactText: "Ja jums ir jautājumi par šo privātuma politiku, vēlaties izmantot savas datu aizsardzības tiesības vai jums ir bažas par to, kā mēs apstrādājam jūsu personas datus, lūdzu, sazinieties ar mums:",
  },
};
